/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestDto } from '../../models/contents-request-dto';

export interface ContentsRequestControllerDelete$Params {
  contentsRequestId: string;
  clientWorkspaceId: string;
}

export function contentsRequestControllerDelete(http: HttpClient, rootUrl: string, params: ContentsRequestControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('contentsRequestId', params.contentsRequestId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestDto>;
    })
  );
}

contentsRequestControllerDelete.PATH = '/api/contents-request/{clientWorkspaceId}/{contentsRequestId}';
